function initTinyMCE() {
    tinymce.init({
        base_url: "/Library/JS/tinymce",
        selector: '.js-rte',
        menubar: false,
        plugins: 'lists link ',
        toolbar: 'formatselect | bold italic |  bullist numlist | link',
        resize: false,
        width: 780,
        height: 200,
        branding: false,
        
        setup: function (editor) {
            editor.on('change blur', function (e) {
                e.target.targetElm.value = editor.getContent();
            });
        },
        
    });
}

$(document).ready(function () {
    $.getScript("/Library/JS/tinymce/tinymce.min.js")
        .done(function () {
            initTinyMCE();
        });
});

